var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "frankinForm__stepOne step" },
      [
        _vm.machines_amount === null
          ? _c(
              "div",
              {
                staticClass:
                  "frankinForm__saveProgress saveProgress saveProgress--full saveProgress--paddingLarge",
                staticStyle: { "margin-top": "0" }
              },
              [
                _c("section", { staticClass: "formIntro" }, [
                  _c("div", { staticClass: "in container" }, [
                    _c("h4", { attrs: { id: "getStarted" } }, [
                      _vm._v("Let’s get started!")
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n            You are just a few minutes away from your franking machine quote.\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n            We search and compare all manufacturer models in the market place\n            e.g. Pitney Bowes, Quadient (Neopost), FP and Frama. No need to speak to\n            salespeople and filter out what is actually best for your\n            business, we provide the facts with a full savings and return on\n            investment calculation.\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "\n            Its important you answer all questions to the best of your\n            ability, the detail entered will be used to calculate your\n            savings, return on investment summary and provide you with a\n            choice of suitable solutions from each manufacturer relevant to\n            your specific business requirements.\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Top tip: If you are currently in a contract, please have this handy to answer any questions our\n            Expert may have."
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-col",
                        staticStyle: { color: "#0a70e3" },
                        attrs: { href: "/quotes-create?form=callback" }
                      },
                      [_vm._v("\n            Request a call back\n          ")]
                    ),
                    _vm._v(" "),
                    _vm.currentStep > 1
                      ? _c(
                          "a",
                          {
                            staticClass: "btn btn--base",
                            attrs: { href: "#", tabindex: "0" },
                            on: { click: _vm.stepBack }
                          },
                          [_vm._v("Go Back")]
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "in container" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "saveProgress__form" }, [
                    _c(
                      "div",
                      {
                        staticClass: "saveProgress__inputBlock",
                        staticStyle: { width: "21.5625rem", margin: "0 auto" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "inputSelect",
                            staticStyle: { "margin-top": "10px" },
                            attrs: { tabindex: "0" }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.machines_amount_view || "Please Select"
                                ) +
                                "\n\n              "
                            ),
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.machines_amount_view,
                                    expression: "machines_amount_view"
                                  }
                                ],
                                staticStyle: {
                                  position: "absolute",
                                  top: "0",
                                  left: "0",
                                  opacity: "0"
                                },
                                attrs: { name: "postagespendpermonth" },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.machines_amount_view = $event.target
                                      .multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              [
                                _c(
                                  "option",
                                  { attrs: { disabled: "", value: "null" } },
                                  [_vm._v("Please Select")]
                                ),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 1 } }, [
                                  _vm._v("1")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 2 } }, [
                                  _vm._v("2")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 3 } }, [
                                  _vm._v("3")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 4 } }, [
                                  _vm._v("4")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 5 } }, [
                                  _vm._v("5")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 6 } }, [
                                  _vm._v("6")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 7 } }, [
                                  _vm._v("7")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 8 } }, [
                                  _vm._v("8")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 9 } }, [
                                  _vm._v("9")
                                ]),
                                _vm._v(" "),
                                _c("option", { domProps: { value: 10 } }, [
                                  _vm._v("10+")
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      attrs: {
                        id: "step1continue",
                        type: "submit",
                        value: "Continue",
                        disabled: _vm.machines_amount,
                        onclick: "window.scrollTo(0, 0);"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.setMachinesAmount()
                        }
                      }
                    })
                  ])
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.machines_amount && _vm.machines_amount >= 2
          ? _c("form-machines-amount-over-10")
          : _vm._e(),
        _vm._v(" "),
        _vm.machines_amount && _vm.machines_amount < 2
          ? _c("form-machines-amount-under-10")
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "in container" },
          [_c("invalid-fields-modal")],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "masthead masthead--inner" }, [
      _c("div", { staticClass: "in" }, [
        _c(
          "div",
          {
            staticClass: "masthead__slide",
            staticStyle: {
              background:
                "url('../../../../../../static/styles/mailkit/img/banner.jpg') center center / cover no-repeat",
              width: "100%",
              display: "inline-block"
            }
          },
          [
            _c("div", { staticClass: "masthead__caption" }, [
              _c("h3", [
                _vm._v(
                  "\n            The Mailing Expert, the UK’s only instant franking machine comparison website.​\n          "
                )
              ]),
              _vm._v(" "),
              _c(
                "p",
                { staticStyle: { "font-size": "24px", "max-width": "none" } },
                [
                  _vm._v(
                    "Compare costs for all manufacturers and machines in minutes!"
                  )
                ]
              )
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [
        _vm._v(
          "Not a fan of forms? Click here to request a call back and have one of our Mailing Experts\n            provide a quote for you."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "saveProgress__content" }, [
      _c("h4", [
        _vm._v("How many offices/machines do you require a quote for?")
      ]),
      _vm._v(" "),
      _c("p")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65c2cda6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65c2cda6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Quotes/Form/Step-1/Form.vue
// module id = null
// module chunks = 